// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3YJTe","actions":"GroupTable_actions__3PJu3","deleteModalFooter":"GroupTable_deleteModalFooter__1cGF9"};